import { TenantGroup } from "./tenant-group.model";

export class Tenant {
    id!: number;
    legalName!: string;
    // identityDocument!: IdentityDocumentVo
    image?: string;
    caepf?: string;
    groupId?: number;
    group?: TenantGroup;
    active!: boolean;
    // companyType?: CompanyType
}